/**
 * @desc 分页
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(params: API.business.customerOrder.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/customerOrder/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
